// SECTIONS

import {
    constables
} from './base.js';

const breakpoint = constables().breakpoint;

const times = constables().times;
const timem = constables().timem;
const timel = constables().timel;

// INIT

export function initnavigation() {

    routes();

}

function routes() {

    let menu = document.getElementById('burger');
    if (menu) {
        menu.addEventListener('click', toggleMenu);
    }

    let index = document.getElementById('index');
    if (index){
        toggleIndex(index);
    }

}

function toggleMenu() {

    document.body.toggleAttribute('menu');

}

function toggleUp() {

    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });

}

function toggleIndex(index) {

    let ul = index.querySelectorAll('a');
    ul.forEach(li => {

        li.addEventListener('click', (e) => {

            let slug = li.getAttribute("slug");
            let article = document.getElementById(slug);

            if (article) {

                e.preventDefault();

                let top = article.getBoundingClientRect().top;

                window.scrollTo({
                    top: top+window.scrollY,
                    behavior: "smooth",
                });

                if (document.body.hasAttribute('menu')){

                    document.body.removeAttribute('menu');

                }

            }

        });

    })

}